var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14354_11063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.332 1.99967H12.6654V9.99967H15.332V1.99967ZM0.665363 9.33301C0.665363 10.0663 1.26536 10.6663 1.9987 10.6663H6.20536L5.57203 13.713L5.55203 13.9263C5.55203 14.1997 5.66536 14.453 5.84536 14.633L6.55203 15.333L10.9387 10.9397C11.1854 10.6997 11.332 10.3663 11.332 9.99967V3.33301C11.332 2.59967 10.732 1.99967 9.9987 1.99967H3.9987C3.44536 1.99967 2.97203 2.33301 2.77203 2.81301L0.758696 7.51301C0.698696 7.66634 0.665363 7.82634 0.665363 7.99967V9.33301Z",
    fill: "#DF6C20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14354_11063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 -1 16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeSelected);
export default __webpack_public_path__ + "static/media/dislikeSelected.4e072549f206f15a48f2edd2cbd1e9ea.svg";
export { ForwardRef as ReactComponent };